import api from "../libs/api";

export default {
	getGroups: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/task-reminder-groups`)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getAllProjectsByForm: (form_id) => {
		let formID = 0;
		if (!form_id) {
			formID = 0;
		} else {
			formID = form_id;
		}
		return new Promise((resolve, reject) => {
			api()
				.get(`/get-projects-of-form?form_id=${formID}`)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getAllSections: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/get-all-sections`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateGroup: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/task-reminder-groups/${id}`, data)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteGroup: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/projects/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	postGroup: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post("task-reminder-groups", data)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getReminders: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/task-reminders`)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	postReminder: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post("task-reminders", data)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateReminder: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/task-reminders/forms/${id}`, data)
				.then(({ status, data }) => {
					if (status === 200 || status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
};
